import { AutogenModelSettlement, AutogenRowSettlement } from "./autogen/AutogenModelSettlement";

export class ModelSettlement extends AutogenModelSettlement<RowSettlement> {
	constructor() {
		super(RowSettlement);
	}
}

export class RowSettlement extends AutogenRowSettlement {
}